export default {
	"item.NoInformationWasObtained": "沒有獲取到資訊",
	"item.AGoodThingToShareWithYou": "給你分享了一個好東西",
	"item.LimitedTimeDiscountedPrices": "限時折扣價",
	"item.ThePosterIsBeingGenerated": "正在生成海報",
	"item.rise": "起"
}